import { render, staticRenderFns } from "./ed-object-preview.vue?vue&type=template&id=3b56980e&scoped=true&"
import script from "./ed-object-preview.ts?vue&type=script&lang=ts&"
export * from "./ed-object-preview.ts?vue&type=script&lang=ts&"
import style0 from "./ed-object-preview.scss?vue&type=style&index=0&id=3b56980e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b56980e",
  null
  
)

export default component.exports